import react, { useEffect } from "react";

const PreviousConversationsList = (props) => {

    const [conversations, setConversations] = react.useState([]);

    const fetchConversations = async (timeFrame = null) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/guide/previous-conversations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${window.localStorage.getItem('guideToken')}`
            },
            body: JSON.stringify({
                timeFrame: timeFrame
            })
        });
        const data = await response.json();
        if (data.success) {
            setConversations(data.notes);
        } else {
            console.error("Failed to fetch conversations");
        }
    };

    useEffect(() => {
        fetchConversations();
    }, []);

    return (
            <>
                <div>
                    <h4 className="lucky-font" style={{fontSize: '1.5rem', textAlign: 'center'}}>Previous Conversations</h4>
                    {conversations.length === 0 ? (
                        <p>No conversations found.</p>
                    ) : (
                        <div className="polaroid-grid">
                            {conversations.map((conversation) => (
                                <div className="polaroid conversation" key={conversation._id}>
                                    <img src={conversation.profilePictureUrl} alt={conversation.customerName} />
                                    <div className="caption">
                                        <h3>{conversation.customerName}</h3>
                                        <p className="note-message-preview">{conversation.message}</p>
                                        <button onClick={() => props.showTheConversationDetails(conversation)}>View Details</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </>
    );
}

export default PreviousConversationsList;